var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.625L0.875 5.875L4.375 7.7825V13.0325L10.5 16.375L16.625 13.0325V7.7825L18.375 6.82875V12.875H20.125V5.875L10.5 0.625ZM16.4675 5.875L10.5 9.13L4.5325 5.875L10.5 2.62L16.4675 5.875ZM14.875 12L10.5 14.38L6.125 12V8.73625L10.5 11.125L14.875 8.73625V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.d372ad91.svg";
export { ForwardRef as ReactComponent };